import { Visibility, VisibilityOff } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Chip, Collapse, GridLegacy as Grid, IconButton, Input, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, DatePickerInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType, FormatPrice } from "../../../utils/constants";
import * as yup from "yup";
import CustomContextMenu from "../../../components/context-menu";
import { FilterForm } from "../../../components/form/filter-form";
import { CustomDialog } from "../../../components/modals/custom-dialog";


const schemaFilter = yup.object({
  

}).required();

const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:"",
  proveedor:null,
  fecha_creacion:null
};


const SubTableDetalle = ({
  items
})=>{

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            Producto
          </TableCell>
          <TableCell>
            Calidad
          </TableCell>
          <TableCell>
            Cantidad
          </TableCell>
          <TableCell>
            Precio x un
          </TableCell>
          <TableCell>
             Valor 
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>

        {
          items.map( data=> <TableRow 
          key={data.cod_orden_detalle}
          >
            <TableCell>
              {data.nombre_producto}
            </TableCell>
            <TableCell>
              {data.calidad}
            </TableCell>
            <TableCell>
              {data.total_un_empaques}  {data.nombre_unidad_medida}
            </TableCell>
            <TableCell>
              $ {FormatPrice(Number(data.precio_unidad_medida))} COP
            </TableCell>
            <TableCell>
              $ {FormatPrice(data.valor_mercancia)} COP
            </TableCell>
          </TableRow> )
        }

      </TableBody>
    </Table>
  )

}

export const  ListadoOrdenesCompras = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [dialogInternalConfig,setDialogInternalConfig] = useState({});



    useEffect(()=>{

      loadProducts();


    },[]);

    useEffect(()=>{
  
      loadProducts( filterSearchPagination.filter_search?false:true );
    
    },[filterSearchPagination]);


    const loadProducts =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/listar-ordenes-compras-comprador",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value?.data || []]);

     setTotalRows(value?.total || 0);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }


    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      console.log({InitialFilterSearch});
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };




    const getOrdenColor= status=>{
      if (status === 'BORRADOR'){
        return "default";
      }
      if (status === 'CONFIRMADA'){
        return "success";
      }
   
      if (status === 'ANULADA'){
        return "error";
      }
      if (status === 'BLOQUEADA'){
        return "warning";
      }
      return "default";
    }
    
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"proveedor",
        keyValue:"proveedor",
        label:"Proveedor",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"fecha_creacion",
        keyValue:"fecha_creacion",
        label:"Fecha de creacion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.value).format(DateFormatString),
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"vlr_neto",
        keyValue:"vlr_neto",
        label:"Valor total",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>`$ ${FormatPrice(props.value)} COP`,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"ind_estado",
        keyValue:"ind_estado",
        label:"Estado",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Chip color={getOrdenColor(props.value)} label={props.value} /> ,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      
       {
      
        key:"acciones",
        keyValue:"cod",
        label:"Acciones",
        headerRender:(props)=>props.label,
        bodyRender:({value,prod_index,info})=><>
         <CustomContextMenu
         title_basic="Acciones"
         menuItems={[
          {
            label:"Ver logs",
            onClick:()=>ShowLogImportacion(prod_index),
            disabled:false

          },
          {
            label:"Desbloquear orden",
            onClick:()=>DesbloquearOrdenCompra(info),
            disabled:info.ind_estado !== 'BLOQUEADA'
          },
          {
            label:"Ver Orden compra",
            onClick:()=>DownloadDocumento(value,'OC'),
            disabled:info.ind_estado !== 'CONFIRMADA'

          },
          {
            label:"Ver Factura",
            onClick:()=>DownloadDocumento(value,'FC'),
            disabled:false,
            disabled:info.ind_estado !== 'CONFIRMADA' || info.ind_facturado != 'SI'

          }
         ]}
          />
        </>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       }

    ];

    const onOpenedDetail = (index)=>{
        const copyData = [...dataSetProdctos];
      copyData[index].opened =  !copyData[index].opened;
      setDataSetProductos(copyData);
    }

    const ShowLogImportacion = (index)=>{
    
      const copyData = [...dataSetProdctos];

      if (copyData[index].log_importacion_erp){
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Log de importacion",
            message: copyData[index].log_importacion_erp,
            type: DialogType.informativo,
            isVisible: true
          }
        });
      }else{
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "No hay logs",
            message: "No hay logs para mostrar",
            type: DialogType.informativo,
            isVisible: true
          }
        });
      }
      
    }


    const DesbloquearOrdenCompra = (info_orden)=>{

      if (info_orden.diff_in_munutes  < 10 ){

        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Operacion no permitida",
            message: "Para poder desbloquear una orden de compra debe <b>esperar 10 minutos despues del bloquedo</b>, Intente nuevamente dentro de <b>"+( 10 - info_orden.diff_in_munutes  )+" minutos </b>",
            type: DialogType.peligro,
            isVisible: true
          }
        });
        return;
      }
    
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      AxiosInstance.get(`maestros/desbloquear-oc/${info_orden.cod}`)
      .then(({data})=>{
      
        if (data.status){
        
          dispatch({
            type: ActionTypes.setModalInfo,
            data: {
              title: "Proceso exitoso",
              message: data.msg,
              type: DialogType.exitoso,
              isVisible: true
            }
          });
        }else{
          dispatch({
            type: ActionTypes.setModalInfo,
            data: {
              title: "Orden no desploqueada",
              message: "Error al tratar de realizar el desbloqueo",
              type: DialogType.peligro,
              isVisible: true
            }
          });
        }

      }).catch(err=>{
        
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error de comunicacion",
            message: "Error al tratar de comunicarse con el servidor",
            type: DialogType.peligro,
            isVisible: true
          }
        });
      }).finally(()=>{
        loadProducts();
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });
    }

    const DownloadDocumento = (cod,tipo)=>{

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      AxiosInstance.get(`maestros/descargar-documento-by-oc/${cod}/${tipo}`)
      .then(({data})=>{
        let element = document.createElement("a");
        element.style.display = 'none';
        element.href = `data:application/pdf;base64,${data.base_64}`;
        element.download =  data.name_pdf;
       // document.body.appendChild(element);
        element.click();
       // document.body.removeChild(element); 
      }).catch(err=>{
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error de consulta documento",
            message: "Se ha presentado un error consultando el documento",
            type: DialogType.informativo,
            isVisible: true
          }
        });
      }).finally(()=>{
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });

    }

    const onSearchProveedor = async (evt,value_search) => {

      if (value_search && value_search.length > 3) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-prov-by-filter", {
            search_query: value_search
          });
          setProveedorOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const InputFilters = [

      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"proveedor",
        InputComponentProps:{
          label:"proveedor",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
          onInputChange: onSearchProveedor,
          options: proveedorOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
      {
        grid:{
          xs:3,
          md:3,
          sm:3
        },
        InputComponent:DatePickerInputWithLabel,
        keyValue:"fecha_creacion",
        inputProps:{
          size:'small',
        },
        InputComponentProps:{
          label:"Fecha de creacion",
          fullWidth:true,
          isLoading:false,
          inputFormat:"DD-MM-YYYY",
          value:null,
          size:'small',
         
         
        }
      },
     
      ];


      const  setFilterAply = (filtros)=>{
        console.log({filtros});
        filtros.fecha_creacion = dayjs(filtros.fecha_creacion).isValid() ?filtros.fecha_creacion:null;
        filtros.proveedor = filtros.proveedor?filtros.proveedor.value:null;
        setFilterSearchPagination({
          ...filterSearchPagination,
          page_number:0,
         ...filtros,
       
        });
       
      }

    return (<>

      <CustomDialog
        {...dialogInternalConfig}
      />
   
    <Grid container spacing={2} >
 
        <Grid item sm={12} xs={12} md={7} >

        <FilterForm
            buttomDist={
              {
                sx:3,
                md:3
              }
            }
            nameFilter={"Buscar orden de compra por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {...InitialFilterSearch}
            }
            onApplyFilter={setFilterAply}
          />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( (prod,prod_index)=>
                 [
                  <TableRow key={prod.cod}  >
                    <TableCell>
                     <IconButton onClick={e=>onOpenedDetail(prod_index)} >
                      {prod.opened?
                      <VisibilityOff />
                      :
                       <Visibility />  
                    }
                  
                     </IconButton>
                    </TableCell>
                  {
                    columnsTable.map(Col=>
                      <TableCell key={Col}  >
                        {<Col.bodyRender  info={prod} value={prod[Col.keyValue]} id={prod.cod} prod_index={prod_index}  />}
                     </TableCell>)
                  }

                </TableRow>,
                <TableRow >
                    <TableCell colSpan={columnsTable.length + 1} >
                      <Collapse in={prod.opened}  unmountOnExit>

                        <SubTableDetalle
                         items={prod.detalle_orden}
                        />
                      
                      </Collapse>
                      </TableCell>
                </TableRow>
                 ]
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}